import { useScope } from "@state/scopeContext.lib";
import { ORGANIZATION_USER_CACHE_KEYS } from "./useOrganizationUserCache";
import { useClearUserCache } from "./useClearUserCache";

/**
 * This call clears all cache that is organization scoped.
 */
export function useClearOrganizationUserCache(): () => void {
    const { activeOrganizationKey } = useScope();

    return useClearUserCache(
        activeOrganizationKey,
        ORGANIZATION_USER_CACHE_KEYS,
    );
}
